const Reflux = require("reflux");
const biAPI = require("app/util/api/bi-api");
const dateToParam = require("./util/date-to-param").dateToParam;

const ProfitableDealOriginsActions = Reflux.createActions({
  "fetchData": { children: ["completed", "failed"] }
});

ProfitableDealOriginsActions.fetchData.listen(function(period, users, funnel) {
  let params = {
    start_date: dateToParam(period.startDate),
    end_date: dateToParam(period.endDate),
    users: users,
    funnel: funnel
  };

  biAPI.fetch("/profitable_deal_origins", params, this.completed, this.failed);
});

module.exports = ProfitableDealOriginsActions;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/actions/profitable-deal-origins-actions.js